import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Header from './Header';
import Card from './Card';
import Msg from './ButtonMsg';
import Find from './Find';

const game = [ 
["Minecraft", "Gra survivalowa w otwartym świecie."],
["Cyberpunk 2077", "RPG w klimacie sci-fi." ],
["The Last Of Us", "Klimatyczne postapo"],
["The Last Of Us II", "Brutalna, emocjonalna przygoda."],
["Ghost of Thushima", "Epicka gra akcji w otwartym świecie, osadzona w feudalnej Japonii."],
["Ori and the Blind Forest", "Piękna, emocjonalna gra platformowa z przepiękną muzyką."]
];

const game1 = [
  ["Minecraft początkowo powstał w 2009 roku i został stworzony przez'Notcha' w zaledwie kilka dni."],
  ["Do stworzenia postaci Johnny'ego Silverhanda Keanu Reeves nagrał ponad 80 godzin materiału do gry."],
  ["Gra zdobyła nagrodę BAFTA za najlepszą grę roku 2014 i została uznana za jedną z najlepszych historii w grach wideo."],
  ["Produkcja zajęła ponad 5 lat i wymagała zaangażowania ponad 200 osób w zespole Naughty Dog."],
  ["W grze użyto prawdziwych technik walki samurajów, a twórcy odwiedzili Japonię, aby odwzorować krajobrazy."],
  ["Gra powstawała przez 4 lata, a każdy fragment świata był ręcznie rysowany, co nadaje jej unikalny wygląd."]
];

const random2 = Math.floor(Math.random() * game1.length);
const fact = game1[random2];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<div style={{backgroundColor: 'lightgrey', height: "100vh"}}>
   <Header/>

   <div style={{ display: "flex", alignItems: "center", padding: "10px", gap: "50px",  justifyContent: "space-between", margin: "50px"}}>
      
   <Find />
   <div style={{ textAlign: "center", fontStyle: "italic"}}>
    <h3>{fact}</h3>
   </div>

   <div>
    <Msg style={{padding: "30px"}}/>
   </div>
   </div>
    
   <div style={{display: "flex"}}>
   {game.map(([title, opis], index) => (
        <Card key={index} title={title} opis={opis} />
      ))}

   </div>
</div>

);


reportWebVitals();
